const getDataProgram = (arrFetch, e, region, allPrograms, quiz = false) => {
  let arr = "",
    operator = '',
    link = '',
    name = '',
    program_group_id = null,
    program_id = null;

  if (!region) {
    return;
  }

  /* Проверяем это option или input */
  if (quiz == true) {
    e = e.target;
  } else {
    e.target ? (e = e.target.options[e.target.selectedIndex]) : e;
  }
  
  /* Из всего списка программ находим свою, независимо от выбранного региона и сохраняем название и id программы */
  let program = allPrograms.find(
    (item) => item.shortname == e.getAttribute("shortname")
  );

  /* Общий ID для программы на всех регионах*/
  program_group_id = program?.program_group_id;
  
  /* Имя программы */
  name = program?.name;
  
  /* Из списка программ, которые отфильстрованы по региону находим свою программу  */
  let filterProgramArr = arrFetch.find(
    (item) => item.shortname == e.getAttribute("shortname")
  );

  if (filterProgramArr == undefined) {
    return {operator, program_id, link, name, program_group_id};
  }

  /* Получаем ссылку с отфильтрованного массива */
  arr = filterProgramArr.regions.find(
    (item) => item.region_id == region
  );

  /* ID Program */
  program_id = arr.program_id;
  
  /* Получение оператора и ссылки на РР */
  arr.fields.forEach(element => {    
    if (element.field == "funnel") {
        operator = element.value
    }  

    if (element.field == "rvr_link") {
        link = element.value
    }    
  });
  
  return {operator, program_id, link, name, program_group_id};
};

export default getDataProgram;
